type Point={x:number;y:number};
type Camera=Point&{zoom:number};
export function targetToViewport(point:Point,camera:Camera){return{x:camera.x+point.x*1329/60*camera.zoom,y:camera.y+point.y*652/28*camera.zoom};}
export function targetFromViewport(point:Point,camera:Camera){return{x:(point.x-camera.x)/camera.zoom/1329*60,y:(point.y-camera.y)/camera.zoom/652*28};}
export function boundTarget(point:Point){return{x:Math.min(60,Math.max(0,point.x)),y:Math.min(28,Math.max(0,point.y))};}
